<template>
  <div>
    <el-form :model="sendOrderForm" label-width="140px">
      <el-form-item label="发货类型：">
        <el-radio-group v-model="sendOrderForm.type">
          <el-radio :label="0">整单发货</el-radio>
          <el-radio :label="1">分批发货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="sendOrderForm.type == 0" label="快递公司：">
        <el-input style="width: 420px;" v-model="sendOrderForm.sendCompany" placeholder="请输入快递公司"></el-input>
      </el-form-item>
      <el-form-item v-if="sendOrderForm.type == 0" label="快递单号：" prop="price">
        <el-input style="width: 420px;" v-model="sendOrderForm.sendNumber" placeholder="请输入快递单号"></el-input>
      </el-form-item>
      <el-form-item v-if="sendOrderForm.type == 1 && goodsData.length > 0" label="">
        <el-table
          border
          :data="goodsData"
          style="width: 100%">
          <el-table-column
            label="商品图片"
            prop="thumb"
            width="90">
            <template slot-scope="scope">
              <el-image
                    style="width: 40px; height: 40px"
                    :src="scope.row.thumb"
                    fit="cover"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsName"
            label="商品名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="specName"
            label="商品规格">
          </el-table-column>
          <el-table-column
            prop="goodsNumber"
            label="商品数量">
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item v-if="sendOrderForm.type == 1 && goodsData.length > 0" label="快递公司：">
        <el-input style="width: 420px;" v-model="sendOrderForm.sendCompany" placeholder="请输入快递公司"></el-input>
      </el-form-item>
      <el-form-item v-if="sendOrderForm.type == 1 && goodsData.length > 0" label="快递单号：" prop="price">
        <el-input style="width: 420px;" v-model="sendOrderForm.sendNumber" placeholder="请输入快递单号"></el-input>
      </el-form-item>
      <el-form-item v-if="sendOrderForm.type == 1" label="">
        <el-button @click="sendGoodsBtn">选择商品发货</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sendSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveGoodsOrderSend } from '@/api/order'
export default {
  name: 'OrderSend',
  props: {
    infoId: {
      type: String,
      default: ''
    },
    goodsData: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      sendOrderForm:{
        sendCompany:'',
        sendNumber:'',
        type:0
      }
    }
  },
  mounted () {

  },
  methods: {
    /* 发货弹窗-保存操作 */
    sendSaveBtn(){
      var that = this;
      var sendOrderForm = that.sendOrderForm;
      if(sendOrderForm.sendCompany == ''){
        this.$message.error('请输入快递公司');
        return false;
      }
      if(sendOrderForm.sendNumber == ''){
        this.$message.error('请输入快递单号');
        return false;
      }
      if(sendOrderForm.type == 1 && that.goodsData.length == 0){
        this.$message.error('请选择商品');
        return false;
      }
      var goodsData = [];
      that.goodsData.forEach(function(item){
        goodsData.push(item.goodsId);
      });
      var passData = sendOrderForm;
      passData.orderId = that.infoId;
      passData.goodsSpecIdList = goodsData;
      that.fullscreenLoading = true;
      saveGoodsOrderSend(passData).then((res) => {
        that.fullscreenLoading = false;
        if (res.errorCode === '0000') {
          that.$message.success(res.msg);
          that.$emit('sendOrderSave', 2, that.infoId);
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    /* 选择发货商品 */
    sendGoodsBtn(){
      this.$emit('sendGoodsData', 1, this.infoId);
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/Send.vue